import React, { useEffect, useRef } from 'react';

const ExternalReviewCarousel = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    // 1. Create and inject the widget script
    const script = document.createElement('script');
    script.src = "https://embed.mylocalbusiness.io/widgets/production/latest/widgets.js";
    script.async = true;
    script.setAttribute('data-my-widget', 'carousel');
    script.setAttribute('data-business-id', '69f441f27d7186dd05cc2f57');
    script.setAttribute('data-location-id', '69f442877d7186dd05cc2f5f');

    if (containerRef.current) {
      containerRef.current.appendChild(script);
    }

    // 2. Define the styling function for GREEN CARDS and WHITE TEXT
    const applyWidgetStyles = (root) => {
      if (!root) return;

      // Targeted Selector for the Review Cards
      const cardSelectors = '[class*="card"], [class*="review-item"], [class*="carousel-item"]';
      const cards = root.querySelectorAll(cardSelectors);

      cards.forEach(card => {
        card.style.setProperty('background', '#4D6148', 'important');
        card.style.setProperty('color', '#ffffff', 'important');
        card.style.setProperty('border', 'none', 'important');
        card.style.setProperty('border-radius', '12px', 'important');

        // Target all children to be white
        const allText = card.querySelectorAll('p, span, div, h1, h2, h3, h4, h5, h6, strong');
        allText.forEach(txt => {
          txt.style.setProperty('color', '#ffffff', 'important');
        });

        // Target stars and icons
        const icons = card.querySelectorAll('svg, path, i');
        icons.forEach(icon => {
          icon.style.setProperty('fill', '#ffffff', 'important');
          icon.style.setProperty('color', '#ffffff', 'important');
        });
      });

      // Ensure the "Powered by" branding is centered and visible (it's on white background now)
      const branding = root.querySelector('a[href*="mylocalbusiness"], a[href*="reviewbuilder"], .mlb-branding');
      if (branding) {
        branding.style.setProperty('display', 'flex', 'important');
        branding.style.setProperty('justify-content', 'center', 'important');
        branding.style.setProperty('margin', '32px auto 0 auto', 'important');
        branding.style.setProperty('text-decoration', 'none', 'important');
      }
    };

    // 3. Persistent monitor for the widget content
    const styleInterval = setInterval(() => {
      if (!containerRef.current) return;

      // Check standard DOM
      applyWidgetStyles(containerRef.current);

      // Check Shadow DOMs
      const allElements = containerRef.current.querySelectorAll('*');
      allElements.forEach(el => {
        if (el.shadowRoot) {
          applyWidgetStyles(el.shadowRoot);
        }
      });
    }, 1000);

    return () => {
      clearInterval(styleInterval);
      if (containerRef.current && script.parentNode === containerRef.current) {
        containerRef.current.removeChild(script);
      }
      const injectedElements = document.querySelectorAll('.mlb-widget-container');
      injectedElements.forEach(el => el.remove());
    };
  }, []);

  return (
    <div className="w-full min-h-[400px] flex flex-col items-center justify-center external-review-carousel-wrapper">
      <style>{`
        /* Scoped CSS Fallback for Light DOM Cards */
        .external-review-carousel-wrapper [class*="card"],
        .external-review-carousel-wrapper [class*="review-item"],
        .external-review-carousel-wrapper [class*="carousel-item"] {
          background-color: #4D6148 !important;
          color: #ffffff !important;
          border-radius: 12px !important;
          border: none !important;
        }

        .external-review-carousel-wrapper [class*="card"] *,
        .external-review-carousel-wrapper [class*="review-item"] * {
          color: #ffffff !important;
        }

        .external-review-carousel-wrapper [class*="card"] svg,
        .external-review-carousel-wrapper [class*="card"] path {
          fill: #ffffff !important;
        }

        /* Centering the branding container */
        .external-review-carousel-wrapper .mlb-branding-container,
        .external-review-carousel-wrapper div:has(> a[href*="mylocalbusiness"]) {
          display: flex !important;
          justify-content: center !important;
          width: 100% !important;
          margin-top: 2rem !important;
        }
      `}</style>
      <div ref={containerRef} className="w-full max-w-7xl mx-auto px-4" />
    </div>
  );
};

export default ExternalReviewCarousel;